import axios from 'axios';
import type { HeaderValue } from '../type';
import type { QueryStringifyOptions } from '../utils';
import { queryStringify } from '../utils';

// ref. https://axios-http.com/kr/docs/req_config
interface CreateHttpClientConfigOptions {
  maxRedirects?: number;
  maxContentLength?: number;
  maxBodyLength?: number;
}

interface CreateHttpClientConfig {
  baseURL: string;
  headers?: Record<string, HeaderValue>;
  withCredentials?: boolean;
  config?: CreateHttpClientConfigOptions;

  /**
   * @see {@link https://github.com/ljharb/qs}
   * @example { skipNulls: true, arrayFormat: 'comma' }
   */
  requestParamsOptions?: QueryStringifyOptions;
}

export const createHttpInstance = ({
  baseURL,
  headers,
  withCredentials = false,
  config,
  requestParamsOptions,
}: CreateHttpClientConfig) => {
  const instance = axios.create({
    ...config,
    baseURL,
    withCredentials,
    /**
     * link: https://github.com/axios/axios#-fetch-adapter
     * default: ['fetch', 'xhr', 'http']
     * description: fetch를 가장 우선으로 찾아 요청을 실행, fetch가 없으면  xhr, http순으로 가능한 선택을하도록함.
     * */
    adapter: ['fetch', 'xhr', 'http'],
  });

  if (headers) {
    instance.interceptors.request.use((config) => {
      Object.entries(headers).forEach(([key, value]) => {
        config.headers.set(key, value);
      });
      return config;
    });
  }

  if (requestParamsOptions) {
    instance.defaults.paramsSerializer = (params) => queryStringify(params, requestParamsOptions);
  }

  return instance;
};
